import React from 'react';
import { omitNonReactProps } from '~/services/utils';
import { IconProps } from '~/types/utils';
import { useTheme } from 'styled-components';

const Facebook = ({ fill, size = '24', ...otherProps }: IconProps) => {
	const theme = useTheme();
	return (
		<svg
			focusable="false"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill={fill ?? theme.colors.icon}
			{...omitNonReactProps(otherProps)}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.4399 14.8802V21.879C10.9483 21.9586 11.4693 22 12 22C12.5306 22 13.0516 21.9586 13.5599 21.879V14.8802H15.8799L16.3199 12.0002H13.5599V10.1002C13.5599 8.85216 14.6399 8.56682 15.1799 8.58016H16.4399V6.14016C11.4959 5.06816 10.3799 7.98682 10.4399 9.58016V12.0002H7.91992V14.8802H10.4399Z"
				fill={fill ?? theme.colors.icon}
			/>
			<path
				d="M10.4399 21.879V14.8802H7.91992V12.0002H10.4399V9.58016C10.3799 7.98682 11.4959 5.06816 16.4399 6.14016V8.58016H15.1799C14.6399 8.56682 13.5599 8.85216 13.5599 10.1002V12.0002H16.3199L15.8799 14.8802H13.5599V21.879C13.0516 21.9586 12.5306 22 12 22C11.4693 22 10.9483 21.9586 10.4399 21.879Z"
				fill={fill !== '#fff' ? 'white' : 'none'}
			/>
		</svg>
	);
};

export default Facebook;
